import { Box, Tooltip, Typography } from "@mui/material";
import CKEditor from "./CKEditor";
import { InfolconIcon } from "./Icons";

interface Props {
  onChange?: any;
  value?: string;
  inputLabel?: string;
  tooltipTitle?: string;
  helperText?: string;
  requiredField?: boolean;
  disabled?: boolean;
  error?: boolean;
  onReady?: any;
  toolbar?: string[];
  placeholder?: string;
  charLimit?: number;
  isEmailEditor?: boolean;
  minHeight?: number;
}

const GKEditor = (props: Props) => {
  const {
    onChange,
    value,
    inputLabel,
    helperText,
    requiredField,
    error,
    onReady,
    toolbar,
    placeholder,
    disabled,
    charLimit,
    isEmailEditor = false,
    minHeight = 200,
    tooltipTitle,
  } = props;

  return (
    <>
      {inputLabel && (
        <Typography
          style={{
            color: "var(--neutral-500)",
            fontSize: "12px",
            fontWeight: 600,
            textTransform: "uppercase",
            display: "flex",
            alignItems: "center",
          }}
        >
          {inputLabel}
          {requiredField && (
            <span
              style={{
                color: `var(--warning-700)`,
              }}
            >
              *
            </span>
          )}
          {tooltipTitle && (
            <Tooltip title={tooltipTitle} arrow>
              <InfolconIcon style={{ marginLeft: "4px" }} />
            </Tooltip>
          )}
        </Typography>
      )}
      <Box
        className="editor-wrapper"
        sx={{
          border: `1px solid var(--neutral-100)`,
          borderColor: error ? `var(--warning-700)` : "var(--neutral-100)",
          borderRadius: "8px",
          marginTop: inputLabel ? "4px" : "0px",
          "& .ck.ck-content.ck-editor__editable ": {
            borderBottom: "none",
            boxShadow: "none",
            minHeight: minHeight,
            borderRadius: "8px !important",
          },
        }}
      >
        <CKEditor
          value={value}
          onChange={onChange}
          onReady={onReady}
          toolbar={toolbar}
          placeholder={placeholder}
          disabled={disabled}
          charLimit={charLimit}
          isEmailEditor={isEmailEditor}
        />
      </Box>
      {!!helperText && (
        <Typography
          color={`var(--warning-700)`}
          fontSize={10.5}
          sx={{ marginTop: "0 !important" }}
        >
          {helperText}
        </Typography>
      )}
    </>
  );
};

export default GKEditor;
